export default __webpack_public_path__ + "static/media/marker.410cec22.svg";